var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('b-col',{staticClass:"px-0"},[_c('search-by-skill')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }